export default "__VITE_ASSET__BDaDxsv5__"